import { callGet, callPost } from '../../services/axios'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import axios from 'axios'
import { GET_PARTNER_NAMES } from '../actionTypes/partner'

export const createPartner = ({ partnerData }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partner/createPartner`, {
        partnerInfo: partnerData
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const updatePartner = ({ partnerData }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partner/updatePartner`, {
        partnerInfo: partnerData
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const uploadPartnerLogo = (file, onUploadProgress) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    let formData = new FormData()
    formData.append('file', file)

    return axios.post(`/api/partner/uploadFileToBucket`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`
        },
        onUploadProgress,
    });
}

export const getAllPartners = () => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/partner/getAllPartners`, token).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get partners list!',
        })
        return Promise.reject(err)
    })
}

export const getPartnerById = ({ partnerId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/partner/getPartnerById`, token, { partnerId }).then(res => {
        return Promise.resolve(res['data'])
    }).catch((err) => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get partners Data!',
        })
        return Promise.reject(err)
    })
}

export const getPartnerNames = () => async (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet('/api/partner/getPartnerNames', token, {}).then(res => {
        dispatch({
            type: GET_PARTNER_NAMES,
            data: res['data']
        })
        return Promise.resolve(res['data'])
    }).catch(err => {
        toast.show({
            title: 'Warning',
            description: 'Failed to get Partner Names!'
        })
    })
}

export const updateCompanyInfo = (companyInfo) => async (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/partner/updateCompanyDetails`, companyInfo, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

